// Pressing progress for a job card.
//
// A pressing line is atomic - not_started / started / completed - so "done" is
// the total of the lines marked completed, and the balance is everything else.
// A line that is merely "started" still counts as outstanding: the pieces are
// not pressed until the line is finished.
export const pressingProgress = (jc) => {
  const lines = [
    ...(jc?.normal_pressing_lines || []),
    ...(jc?.hot_pressing_lines || []),
    ...(jc?.veneer_pressing_lines || []),
  ];
  const size = (l) => l.total || (l.ply_qty || 0) * (l.side || 1) || 0;
  const planned = lines.reduce((s, l) => s + size(l), 0);
  const done = lines
    .filter((l) => l.status === 'completed')
    .reduce((s, l) => s + size(l), 0);
  return {
    planned,
    done,
    balance: Math.max(0, planned - done),
    lines: lines.length,
    linesDone: lines.filter((l) => l.status === 'completed').length,
    pct: planned > 0 ? Math.round((done / planned) * 100) : 0,
    hasPressing: lines.length > 0,
  };
};
